import React, { useMemo } from "react";
import PropTypes from "prop-types";
import UnifiedSearchAutocompleteComponent from "../unified_search_autocomplete_component";

const ShiftLogClientFilter = ({ options, value = "" }) => {
  const normalizedOptions = useMemo(() => {
    const names = options.flat().filter((option) => typeof option === "string" && option.trim());

    return [...new Set(names)].map((name, index) => ({ id: index, name }));
  }, [options]);

  return (
    <UnifiedSearchAutocompleteComponent
      input_field_name="search_log"
      selected_name={value}
      options={normalizedOptions}
      hardCodedOptions={[]}
      inputFieldId="auto-complete-shift-log-input-box"
      inputFieldPlaceholder="Search by client name"
      renderForm={false}
      showSubmitButton={false}
      showClearButton={false}
    />
  );
};

ShiftLogClientFilter.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
  ).isRequired,
  value: PropTypes.string
};

export default ShiftLogClientFilter;
